import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="flex w-full flex-1 items-center justify-center px-4 pt-16">
        <div className="w-full max-w-lg text-center">
          <p className="font-heading text-[96px] font-black leading-none text-background-300 select-none">
            404
          </p>
          <h1 className="mt-3 font-heading text-xl font-black text-foreground-950 md:text-2xl">
            页面走丢了
          </h1>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">
            你访问的页面不存在或已被移动。可以回到首页继续浏览最新与热门的国产影视作品。
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
            <Link
              to="/"
              className="inline-flex items-center gap-1.5 rounded-md bg-primary-600 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-4-line" />
              返回首页
            </Link>
            <Link
              to="/search"
              className="inline-flex items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-search-line" />
              去搜索影视
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}